import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsVisible(false);
    setIsLoading(true);
    window.scrollTo({ top: 0, behavior: "instant" });
    
    // Small delay to show loading and trigger the fade-in animation
    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
      setIsVisible(true);
    }, 150);

    return () => clearTimeout(loadingTimer);
  }, [pathname]);

  return (
    <>
      {/* Loading indicator */}
      <div
        className={`fixed top-0 left-0 right-0 z-[100] h-0.5 bg-steel transition-all duration-300 ${
          isLoading ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0"
        }`}
        style={{ transformOrigin: "left" }}
      />
      
      {/* Page content with transition */}
      <div
        className={`transition-all duration-300 ease-out ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
        }`}
      >
        {children}
      </div>
    </>
  );
};

export default PageTransition;
